<template>
  <div class="reason-response-field">
    <div class="mb-4">
      <div class="w-full mb-4">
        <strong>{{ name }}</strong>
      </div>

      <div class="w-full">
        <money 
          class="money w-full mb-4" 
          v-model="value" 
          v-bind="money"
          @blur.native="updateValue"
          v-validate="isRequired ? 'required|greaterThanZero' : '' "
          :name="'currency' + index"
          :disabled="disabled"
        ></money>

        <span class="text-danger text-sm" v-show="errors.has('currency' + index)">
          O campo moeda não pode ser zerado ou negativo.
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CurrencyField',
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      items: {
        type: Array,
        required: false
      },
      description: {
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        value: 0.00,
        isRequired: false,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false,
          min: 1
        }
      }
    },
    computed:  {
      name(){
        if ( !this.description || this.description.description == ''){
          return;
        } 
        else if ( this.description.description ){
          return this.description.description;
        }
        return this.description;
      }
    },
    methods: {
      updateValue() {
        this.$emit('valueChanged', this.index, 0, this.value)
      }
    },
    created() {
      this.$validator.extend(
        'greaterThanZero',{
          getMessage: field =>  field + ' needs to be > zero.',
          validate: (value) => {
            if (value > 0 ) return true;
            return false;
          }
      });

      if (!this.items) { return;}
      this.items.forEach((item) => {
        this.isRequired = item.reason_option_is_required

        if(!item.value){ return; }
        this.value = parseFloat( item.value )
      })
    }
  }
</script>
<style lang="scss">
  .reason-response-field {
    .no-arrow {
      button {
        display: none;
      }
    }
  }
</style>

<style scoped>
  .money {
    padding: 0.7rem !important;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    color: #494949;
    font-size: 14px;

  }
</style>
